<template>
    <div>
        <app-sub-title text="Crear formato" />
        <b-card>
            <b-card-header>
                <div>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group
                                label="Nombre del formato"
                                label-for="name"
                            >
                                <b-form-input
                                    v-model="name"
                                    type="text"
                                    name="name"
                                    id="name"
                                    :error="$v.name.$error"
                                    @input="$v.name.$touch()"
                                >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-group label="Versión" label-for="version">
                                <b-form-input
                                    v-model="version"
                                    type="text"
                                    name="version"
                                    id="version"
                                    :error="$v.version.$error"
                                    @input="$v.version.$touch()"
                                >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group label="Código" label-for="code">
                                <b-form-input
                                    v-model="code"
                                    type="text"
                                    name="code"
                                    id="code"
                                    :error="$v.code.$error"
                                    @input="$v.code.$touch()"
                                >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group
                                description="Estado del formato"
                                label="Activo"
                                label-for="active"
                            >
                                <b-form-radio-group
                                    v-model="active"
                                    id="active"
                                >
                                    <b-form-radio :value="0">No</b-form-radio>
                                    <b-form-radio :value="1" checked="true"
                                        >Si</b-form-radio
                                    >
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-card-header>
            <b-card-body>
                <app-sub-title text="Configuración de campos" />
                <b-row v-for="field in fields" :key="field.id">
                    <b-col>
                        <app-dinamic-field
                            :id="field.id"
                            v-model="field.name"
                            :name="field.name"
                            :type="field.type"
                            :order="field.order"
                            :required="field.required"
                            :meta="field.meta"
                            @changeType="handleChangeType"
                            @changeOrder="handleChangeOrder"
                            @changeRequired="handleChangeRequired"
                            @changeMeta="handleChangeMeta"
                            @changeName="handleChangeName"
                        >
                        </app-dinamic-field>
                        <b-btn variant="danger" @click="removeField(field)">
                            Eliminar
                        </b-btn>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-btn variant="info" @click="addField"
                            >+ Agregar Campo</b-btn
                        >
                    </b-col>
                </b-row>
            </b-card-body>
            <button class="btn btn-primary" @click="startSave">
                <i class="fa fa-plus"></i> Crear Formato
            </button>
        </b-card>
        <app-pop-up title="Confirmación" id="save-format">
            <div slot="body">
                <h3>¿Esta seguro que desea crear este formato?</h3>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="save()">
                    <i class="fa fa-trash" aria-hidden="true"></i> Confirmar
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import Title from '../../../UI/Layout/Title.vue'
import PageContent from '../../../UI/Layout/PageContent.vue'
import DinamicField from './DinamicField.vue'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
export default {
    components: {
        appPageContent: PageContent,
        appDinamicField: DinamicField,
        appTitle: Title,
    },
    data: () => ({
        name: '',
        version: '',
        code: '',
        active: 1,
        fields: [],
    }),
    validations: {
        name: {
            required,
        },
        version: {
            required,
        },
        code: {
            required,
        },
        active: {
            required,
        },
    },
    computed: {
        isValidSaving() {
            return (
                this.name != '' &&
                this.version != '' &&
                this.code != '' &&
                this.active != '' &&
                this.fields.length > 0
            )
        },
    },
    methods: {
        addField() {
            const field = {
                ...this.getFieldStructure(),
            }
            this.fields.push(field)
        },
        getFieldStructure() {
            return {
                id: new Date().getTime(),
                name: '',
                type: '',
                meta: '',
                order: '0',
                required: true,
            }
        },
        handleChangeName(val) {
            let field = this.fields.find(item => {
                console.log(item.id)
                return item.id == val.id
            })
            if (field) {
                console.log(val.name)
                field.name = val.name
            }
        },
        handleChangeType(val) {
            let field = this.fields.find(item => {
                return item.id == val.id
            })
            if (field) {
                field.type = val.type
            }
        },
        handleChangeOrder(val) {
            let field = this.fields.find(item => {
                return item.id == val.id
            })
            if (field) {
                field.order = val.order
            }
        },
        handleChangeRequired(val) {
            let field = this.fields.find(item => {
                return item.id == val.id
            })
            if (field) {
                field.required = val.required
            }
        },
        handleChangeMeta(val) {
            let field = this.fields.find(item => {
                return item.id == val.id
            })
            if (field) {
                field.meta = val.meta.replace(new RegExp('\r?\n', 'g'), '')
            }
        },
        removeField(field) {
            let index = this.fields.findIndex(item => {
                return item.id == field.id
            })
            this.fields.splice(index, 1)
        },
        getId(id, tag) {
            return tag + id.toString()
        },
        async startSave() {
            let params = {
                personId: this.user.id,
                // ...this.current,
                name: this.name,
                version: this.version,
                code: this.code,
                active: this.active,
                fields: this.fields,
            }
            if (!this.isValidSaving) {
                toastr.warning(
                    'Complete datos de Nombre, versión y agregue uno o más campos',
                    'No es posible realizar acción'
                )
                return
            }
            //console.log(this.fields)
            console.log(params)
            this.$bus.$emit('save-format.open')
        },
        async save() {
            let params = {
                personId: this.user.id,
                // ...this.current,
                name: this.name,
                version: this.version,
                code: this.code,
                active: this.active,
                fields: this.fields,
            }
            console.log(params)
            //const { data } = await this.$repo.post('formats', params)
            const { data } = await repo.post('formats', params)
            if (data.status) {
                this.$bus.$emit('save-format.close')
                this.$router.push({ name: 'formatsPage' })
            } else {
                toastr.error(data.msg)
                this.$emit('error', data)
            }
        },
    },
}
</script>
